import { Skeleton } from '@/components/Skeleton/Skeleton'
import { productItemSkeleton } from './ProductItemSkeleton.css'

export const ProductItemSkeleton = () => <Skeleton className={productItemSkeleton} />
